// Persona Opportunities – script and brief version history labels.

/**
 * Joins the cells a merged manual version touched into one `changeLabel`.
 * `packages/db` writes it and the Scripts-tab history drawers split on it, so both sides
 * must agree. No single-cell label contains it.
 */
export const VERSION_CHANGE_LABEL_SEPARATOR = ', ';

export function splitVersionChangeLabel(label: string | null | undefined): string[] {
  if (!label) return [];
  return label
    .split(VERSION_CHANGE_LABEL_SEPARATOR)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

/** Appends `next` to an existing label, keeping first-edit order and naming each cell once. */
export function mergeVersionChangeLabels(existing: string | null | undefined, next: string): string {
  const parts = splitVersionChangeLabel(existing);
  if (!parts.includes(next)) parts.push(next);
  return parts.join(VERSION_CHANGE_LABEL_SEPARATOR);
}
